import { $ } from '../utils/Utils';

const analytics = (() => {
  const triggers = [...$('.js-analytics')];

  const handleClick = (trigger) => {
    let eventLabel;
    const t = trigger.dataset.type.toLowerCase();

    switch (t) {
      case 'checkout':
        eventLabel = 'Beställ kurs';
        break;
      case 'interest':
        eventLabel = 'Beställ info';
        break;
      case 'demo':
        eventLabel = 'Boka demo';
        break;
      default:
        eventLabel = 'uncategorized';
        break;
    }

    try {
      ga('send', 'event', 'formConversion', 'formSubmit', eventLabel);
    } catch(e) {
      console.log('Seems to have an issue with Google analytics:', e);
    }
  };

  const build = () => {
    triggers.forEach(trigger => {
      trigger.addEventListener('click', () => handleClick(trigger));
    })
  };

  const init = () => {
    if (triggers.length > 0) {
      build();
    }
  };

  return {
    init,
  };
})();

export default analytics.init();



// WEBPACK FOOTER //
// ./components/analytics.js